import { CreditTier } from "@/app/types/billing/CreditTier";

export class UCreditOffer {
  public static monthlyPriceEur(
    tier: CreditTier,
    annual: boolean,
    discountPercent: number,
  ): number {
    return annual
      ? Math.round(tier.monthlyPriceEur * (1 - discountPercent / 100))
      : tier.monthlyPriceEur;
  }

  public static publicPriceEur(founderPriceEur: number, founderDiscountPercent: number): number {
    return Math.round(founderPriceEur / (1 - founderDiscountPercent / 100));
  }

  public static annualPriceEur(tier: CreditTier, discountPercent: number): number {
    return UCreditOffer.monthlyPriceEur(tier, true, discountPercent) * 12;
  }

  public static formatCredits(credits: number, lang: string): string {
    return credits.toLocaleString(lang);
  }
}
